import script from "./DashboardPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./DashboardPage.vue?vue&type=script&lang=ts&setup=true"

import "./DashboardPage.vue?vue&type=style&index=0&id=8a2a2f1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a2a2f1e"]])

export default __exports__